import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  fetchUserDetails,
  setTableView,
  setUpdateFilterStates,
} from '@/redux/features/UserSlice';
import { getCurrentFinancialYear, getToken } from '@/utility/helper';
import { AppDispatch } from '@/redux/store';
const useResetFiltersOnReload = () => {
  const dispatch = useDispatch<AppDispatch>();
  const token = getToken();
  useEffect(() => {
    if (!dispatch) return;
    const wasReloaded = localStorage.getItem('wasPageReloaded') === 'true';
    if (wasReloaded) {
      if (token) {
        dispatch(fetchUserDetails());
      }
      localStorage.removeItem('wasPageReloaded');
      dispatch(
        setUpdateFilterStates({
          currentPage: 1,
          pageSize: 10,
          count: 0,
          totalPages: 0,
          // sortByDate: [
          //   moment(moment().subtract(30, 'days').toDate()).format('YYYY-MM-DD'),
          //   moment(moment().toDate()).format('YYYY-MM-DD'),
          // ],
          year: getCurrentFinancialYear(),
          companyId: '',
          attendanceStatus: '',
          attendanceType: '',
          siteId: '',
          dashboardSiteId: '',
          department: '',
          designation: '',
          requestType: '',
          stockStatus: '',
          vendorId: '',
          empStatus: 'current',
          customerId: '',
          customerCompanyId: '',
          orderBy: '',
        }),
      );
      dispatch(setTableView('table'));
      // dispatch(
      //   setDateFilter([
      //     moment().startOf('month').format('YYYY-MM-DD'),
      //     moment().endOf('month').format('YYYY-MM-DD'),
      //   ]),
      // );
    }
    const handleBeforeUnload = () => {
      localStorage.setItem('wasPageReloaded', 'true');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [dispatch, token]);
};

export default useResetFiltersOnReload;
